import { IFetchUnitPaymentMethodsDTO } from 'modules/customer/domain/dtos';
import { IUnitPaymentMethodsRepository } from 'modules/customer/domain/repositories';

export class FetchUnitPaymentMethodsUseCase {
  constructor(
    private unitPaymentMethodsRepository: IUnitPaymentMethodsRepository,
  ) {}

  public async execute({ unitId }: IFetchUnitPaymentMethodsDTO) {
    return this.unitPaymentMethodsRepository.findAll({
      unitId,
    });
  }
}
